"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mainLinksTemplateColumns = exports.mainTemplateAreas = exports.Wrapper = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _utils = require("../../utils");

var Wrapper = _stylitas.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow: hidden;\n  padding-top: 64px;\n  background-color: ", ";\n\n  ", "\n"])), _utils.componentToken.footer.main.backgroundColor, _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding-top: 80px;\n  "]))));

exports.Wrapper = Wrapper;
var mainTemplateAreas = {
  xs: "\n    \"".concat('mainLinks '.repeat(4), "\"\n    \"").concat('appLinksContainer '.repeat(4), "\"\n    \"").concat('image '.repeat(4), "\"\n  "),
  md: "\n    \"".concat('mainLinks '.repeat(8), " ").concat('image '.repeat(4), "\"\n    \"").concat('appLinksContainer '.repeat(4), " ").concat('. '.repeat(4), " ").concat('image '.repeat(4), "\"\n  ")
};
exports.mainTemplateAreas = mainTemplateAreas;
var mainLinksTemplateColumns = {
  xs: 'repeat(1, 1fr)',
  md: 'repeat(4, 1fr)'
};
exports.mainLinksTemplateColumns = mainLinksTemplateColumns;